import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { updateTrainingPlan } from "../helpers/requests";

const EditTrainingPlanModal = ({
  setShowEditPlanModal,
  plan,
  handleUpdatePlan,
}) => {
  const { t } = useTranslation();
  
  const [expirationDate, setExpirationDate] = useState(
    plan.expirationDate ? 
    new Date(plan.expirationDate._seconds ? plan.expirationDate._seconds * 1000 : plan.expirationDate).toISOString().split('T')[0] 
    : ""
  );
  const [logoutAfterTraining, setLogoutAfterTraining] = useState(plan.logoutAfterTraining || false);
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setIsLoading(true);

    const updateData = {
      expirationDate: expirationDate === "" ? null : expirationDate,
      logoutAfterTraining
    };

    try {
        await updateTrainingPlan(plan.id, updateData);
        handleUpdatePlan({ 
            ...plan, 
            ...updateData,
            expirationDate: updateData.expirationDate ? new Date(updateData.expirationDate) : null
        });
        setShowEditPlanModal(false);
    } catch (error) {
        console.error("Failed to update training plan:", error);
    } finally {
        setIsLoading(false);
    }
  };

  return (
    <div className="confirmation-modal">
      <div className="modal-content">
        <div style={{ textAlign: "center", fontSize: "1.3em" }}>
          {t("Edit_training_plan")}
        </div>
        <form onSubmit={handleSubmit} className="m-4">
          
          {/* Read-only Fields */}
          <div className="mb-3" style={{ marginTop: "2vh" }}>
            <label style={{ marginLeft: "20px", color: "#404040", fontWeight: "bold" }}>{t("Headset")}</label>
            <input 
                type="text" 
                className="form-control" 
                value={plan.headsetName} 
                disabled 
                style={{ backgroundColor: "#e9ecef", borderRadius: "20px", color: "#404040", height: "5vh", maxHeight: "40px", fontSize: "1em", paddingLeft: "20px" }} 
            />
          </div>

          <div className="mb-3" style={{ marginTop: "2vh" }}>
            <label style={{ marginLeft: "20px", color: "#404040", fontWeight: "bold" }}>{t("User")}</label>
            <input 
                type="text" 
                className="form-control" 
                value={plan.userName} 
                disabled 
                style={{ backgroundColor: "#e9ecef", borderRadius: "20px", color: "#404040", height: "5vh", maxHeight: "40px", fontSize: "1em", paddingLeft: "20px" }} 
            />
          </div>

          {/* Editable Fields */}
          <div className="mb-3" style={{ marginTop: "2vh" }}>
            <label style={{ marginLeft: "20px", color: "#404040", fontWeight: "bold" }}>{t("Expiration_Date")}</label>
            <input
              type="date"
              className="form-control"
              value={expirationDate}
              onChange={(e) => setExpirationDate(e.target.value)}
              style={{ backgroundColor: "#CCCCCC", borderRadius: "20px", color: "#404040", height: "5vh", maxHeight: "40px", fontSize: "1em", paddingLeft: "20px" }}
            />
          </div>

          {/* Logout Checkbox */}
          <div className="mb-3 form-check custom-checkbox" style={{ marginTop: "2vh" }}>
            <label className="custom-checkbox-label">
                <input
                    type="checkbox"
                    className="form-check-input"
                    checked={logoutAfterTraining}
                    onChange={(e) => setLogoutAfterTraining(e.target.checked)}
                />
                <span className="checkmark"></span>
                <span className="form-check-label">{t("Logout_after_each_training")}</span>
            </label>
          </div>

          <div className="button-container">
            <button
              type="button"
              className="buttonCancel btn btn-primary"
              onClick={() => setShowEditPlanModal(false)}
            >
              {t("Cancel")}
            </button>
            <button
              type="submit"
              className="btn btn-primary buttonAcceptGreen"
              disabled={isLoading}
            >
              {t("Save")}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditTrainingPlanModal;